export const TYPE = '@type';

/** @deprecated Sender map entries are always loaded. */
export const STARTED = 'STARTED';
/** @deprecated Sender map entries are always loaded. */
export const SUCCEEDED = 'SUCCEEDED';